<template>
  <div>
    <div class="primeira-via">
      <impresso
        via="1"
        destino="DRH"
        :nomeServidor="nomeFuncionario"
        :servidor="funcionario"
        :dataSolicitada="dataSolicitacao"
        :dataDaFalta="dataFalta"
        :mostraDataSolicitada="mostraInputSolicitacao"
        :mostraDataFalta="mostraInputFalta"
      />
    </div>
    <div class="segunda-via">
      <impresso
        via="2"
        destino="Solicitante"
        :nomeServidor="nomeFuncionario"
        :servidor="funcionario"
        :dataSolicitada="dataSolicitacao"
        :dataDaFalta="dataFalta"
        :mostraDataSolicitada="mostraInputSolicitacao"
        :mostraDataFalta="mostraInputFalta"
      />
    </div>
  </div>
</template>
<script>
import Impresso from './impresso';

export default {
  data() {
    return {
      funcionario: {},
      nomeFuncionario: '',
      dataFalta: '',
      dataSolicitacao: '',
      mostraInputSolicitacao: false,
      mostraInputFalta: false,
    };
  },
  methods: {
    obtemDatasEFuncionario() {
      const indexFuncionario = this.$route.params.index;
      const diaFaltoso = this.$route.params.diaFalta;
      const mesFaltoso = this.$route.params.mesFalta;
      const anoFaltoso = this.$route.params.anoFalta;
      const diaSolicitado = this.$route.params.diaSolicitacao;
      const mesSolicitado = this.$route.params.mesSolicitacao;
      const anoSolicitado = this.$route.params.anoSolicitacao;

      this.funcionario = this.$store.state.usuarioLogado.funcionarios[
        indexFuncionario
      ];
      this.nomeFuncionario = this.$store.state.usuarioLogado.nome;
      this.dataFalta = `${diaFaltoso}/${mesFaltoso}/${anoFaltoso}`;
      this.dataSolicitacao = `${diaSolicitado}/${mesSolicitado}/${anoSolicitado}`;
    },
  },
  created() {
    this.obtemDatasEFuncionario();
  },
  mounted() {
    window.print();
    this.$router.go(-1);
  },
  components: {
    Impresso,
  },
};
</script>

<style scoped>
.primeira-via {
  margin-bottom: 1cm;
  overflow: auto;
}
.segunda-via {
  clear: both;
  border-top: 1px dashed #000;
  padding-top: 1cm;
  overflow: auto;
}

@page {
  margin: 0;
  padding: 0;
  background-image: none;
}
</style>



// WEBPACK FOOTER //
// pagina-impresso.vue?5163c55e